import styled from 'styled-components'

export default styled.div`
  max-width: 60%;
  margin: 0 auto;
`
